export class ActivityModel {
    keyword = '';

    clinic_id = '';
    created_by = '';
    patient_id = '';
    type = null;
    created_at = '';
    se_status = '';
    se_updated_at = '';
    se_reminder = '';
    se_reminder_update = '';
    di_status = '';
    di_status_update = '';
    di_archive_date = '';

    se_reminder_update_from = '';
    se_reminder_update_to = '';

    se_updated_at_from = '';
    se_updated_at_to = '';

    di_status_update_from = '';
    di_status_update_to = '';

    di_archive_date_from = '';
    di_archive_date_to = '';
}
